import styled from "styled-components";

export const ChartWrapper = styled.div`
  min-width: 0;
  min-height: 0;
  width: 100%;
  height: 100%;
  padding: ${({ $expanded }) => ($expanded ? "8px 10px 5px" : "0 1px")};
  display: flex;
  flex-direction: column;
  background: ${({ $expanded }) =>
    $expanded ? "rgba(2, 13, 20, 0.55)" : "transparent"};
  border: ${({ $expanded }) =>
    $expanded ? "1px solid rgba(52, 86, 101, 0.38)" : "0"};
  border-radius: ${({ $expanded }) => ($expanded ? "10px" : "0")};
`;

export const ChartHeader = styled.div`
  min-height: ${({ $expanded }) => ($expanded ? "20px" : "8px")};
  padding: 0 0 ${({ $expanded }) => ($expanded ? "4px" : "0")};
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ChartTitle = styled.h3`
  margin: 0;
  color: #f4f7f9;
  font-size: ${({ $expanded }) => ($expanded ? "15px" : "8px")};
  font-weight: 650;
  line-height: 1;
`;

export const LegendDot = styled.span`
  width: ${({ $expanded }) => ($expanded ? "8px" : "4px")};
  height: ${({ $expanded }) => ($expanded ? "8px" : "4px")};
  border-radius: 50%;
  background: ${({ $color }) => $color};
  box-shadow: 0 0 12px ${({ $color }) => $color};
`;

export const ChartBody = styled.div`
  min-height: 0;
  width: 100%;
  flex: 1 1 auto;
`;
